import React, {useState, useEffect, useContext} from "react";
// import Link from "next/link";
import { Button } from "@chakra-ui/button";
import { useSession } from "next-auth/react";
import { removeDuplicates } from "utils/tweetUtils";
import { useColorModeValue, useColorMode } from "@chakra-ui/color-mode";
import {
    Box,
    Flex,
    Text,
    useMediaQuery,
    useDisclosure,
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    Image,
    Center,
    Link,
    Tabs,
    Tab,
    TabList,
    TabPanel,
    TabPanels,
} from "@chakra-ui/react";
import { firebaseClient, getToken } from "firebaseClient";
import { useRouter } from "next/dist/client/router";
import { ChevronDownIcon } from '@chakra-ui/icons';
import { useFirebaseUser } from "../../utils/useFirebaseUser";
import { TweetBar } from "components/queue-panels/tweet-bar";
import PuffLoader from "react-spinners/PuffLoader";
import { TweetContext } from "context/tweetContext";
import { CreatorListItem } from "components/scheduler/creatorListItem";
import { GhostwriterAllContent } from "./ghostwriterAllContent";
import { GhostwriterAllClients } from "./ghostwriterAllClients";
import { fetchContracts } from "controllers/ghostController";

let tabs = [
    "My Clients",
    "All Content",
]

export const GhostwriterPanel = ({query}) => {

    const { colorMode, toggleColorMode } = useColorMode();
    const router = useRouter();
    const { data: session, status } = useSession() ?? {}
    const loading = status === "loading"
    const isAuthenticated = useFirebaseUser();
    const [isTooSmall] = useMediaQuery("(max-width: 600px)");

    const [isUpdating, setIsUpdating] = React.useState(false);
    const [tweets, setTweets] = useState<any[]>([]);
    const [tweetsFiltered, setTweetsFiltered] = useState<any[]>([]);
    const tweetContext: any = useContext(TweetContext);
    const [selectedCreator, setSelectedCreator] = useState<any>(undefined);
    const [tabIndex, setTabIndex] = useState<number>(0);

    const [clients, setClients] = React.useState([]);


    const handleTabChange = (tabIndex = 0) => {
        setTabIndex(tabIndex);
        router.push({
            pathname: '/collaboration',
            query: { tab: tabs[tabIndex], mode: "ghostwriter" }
        }, undefined, { shallow: false });
    }

    const changeTabFromQuery = (query) => {
        if (query.tab) {
            let match = tabs.find(x => x == query.tab);
            if (match) {
                let index = tabs.indexOf(match);
                setTabIndex(index);
            }
        }
    }

    useEffect(() => {
        console.log("change tab to: " + query.tab);
        changeTabFromQuery(query);
    }, [query.tab]);

    useEffect(() => {
        if (isAuthenticated) {
            let accounts = session?.user?.data?.linkAccounts ?? [];
            setClients(accounts);
        }
    }, [isAuthenticated, tweetContext.refresh]);

    return (
        <Box>
            {
                (session?.user?.data?.ghostwriterData || session?.user?.data?.isBeta) && (
                    <Flex justifyContent="flex-end" alignItems="center" w="100%" mt="0" pb={0}>
                        <Flex>
                            <Button
                                variant="outline"
                                size="sm"
                                as={Link}
                                href="/ghostwriter"
                            >
                                Ghostwriting Settings (beta)
                            </Button>
                        </Flex>
                    </Flex>
                )
            }
            <Tabs mt={5} 
                index={tabIndex}
                onChange={(index) => {
                    handleTabChange(index);
                }}
                isLazy
            >
                <TabList gap={2}>
                    <Tab>Your Clients</Tab>
                    <Tab>All Content</Tab>
                </TabList>
                <TabPanels mt={5}>
                    <TabPanel px="0">
                        <GhostwriterAllClients setTabIndex={setTabIndex} setSelectedCreator={setSelectedCreator}/>
                    </TabPanel>
                    <TabPanel px="0">
                        <GhostwriterAllContent selectedCreator={selectedCreator} setSelectedCreator={setSelectedCreator} />
                    </TabPanel>
                </TabPanels>
            </Tabs>
        </Box>
    );
};  
